module.exports = "<div id=\"return-to-top\" class=\"return-to-top hide\" (click)=\"returnToTop()\"><i class=\"icon chevron up\"></i></div>\r\n"